import React from 'react';
import {Image} from 'antd'


const ChatQuestion = (props) =>  {
    const data = props.question;

    return (
        <div className="p-4">
            {
                data.map((res,i)=>{
                    return (
                        <div key={'chatque'+i}>
                        {
                            res?.type==='text'?<span style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word'}}>{res.text}</span>:
                                ''
                        }
                        </div>
                    )
                })
            }
            {
                data.map((res,i)=>{
                    return (
                        <div className={'chatQuestionImg'} key={'chatqueimg'+i}>
                            {
                                res?.type!=='text'?<div className={'chatQuestionImg'}>
                                        <Image className={'cqimg'} style={{display:'inline-block'}} src={res.image_url.url} width={100} preview={false}></Image>
                                    </div>:
                                    ''
                            }
                        </div>
                    )
                })
            }

        </div>
    );
}



export default ChatQuestion
